
import { Routers } from './Routers/routers';
import { BrowserRouter } from 'react-router-dom';
import { AuthRoutes } from './Routers/AuthRoutes/AuthRoutes';
import { Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { AutoLogout } from "./Utils/helpers/AutoLogout";
import { InternetStatusPopup } from './Utils/helpers/InternetStatusPopup';
import { useEffect } from 'react';

function AppWrapper() {
  const queryClient = new QueryClient();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position='top-right' closeButton />
      <InternetStatusPopup />
      <AuthRoutes />
      <Routers />
      {/* {isLoggedIn && <AutoLogout timeout={1000 * 60 * 120} />} */}
    </QueryClientProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}
